import { render, staticRenderFns } from "./title-image.vue?vue&type=template&id=f631c3f0&scoped=true"
import script from "./title-image.vue?vue&type=script&lang=js"
export * from "./title-image.vue?vue&type=script&lang=js"
import style0 from "./title-image.vue?vue&type=style&index=0&id=f631c3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f631c3f0",
  null
  
)

export default component.exports